import { Bot } from 'lucide-react';

interface ErrorStateProps {
  error: Error;
}

export function ErrorState({ error }: ErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-6">
      <div className="w-20 h-20 rounded-full bg-[#2a2a35] flex items-center justify-center mb-6">
        <Bot className="w-10 h-10 text-white" />
      </div>
      <h3 className="font-['Poppins',sans-serif] text-2xl font-semibold text-white mb-3">
        Failed to Load Characters
      </h3>
      <p className="text-[#9595a5] text-center mb-6 max-w-md">
        {error.message || 'Unable to fetch characters. Please try again later.'}
      </p>
    </div>
  );
}
